"use strict";
var _categoryPageData_application, _categoryPageData_application_rootEditorialLandingPage, _categoryPageData_application1;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mappedCategoryPageData = exports.categoryPageData = void 0;
var _articles = require("./articles");
var _categories = require("./categories");
var _description = require("./description");
const categoryPageData = exports.categoryPageData = {
    application: {
        rootEditorialLandingPage: {
            themeItems: _categories.categories
        },
        editorialLandingPage: {
            landingPageId: 'Novage+',
            description: _description.description,
            editorialItems: _articles.articles,
            themeItems: [],
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=fa01fbdb-d631-48d7-b6ec-4ec57ef4b039&name=fragrance&inputFormat=jpg',
            themeTag: 'Editorials',
            thumbnailUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=856697f4-5936-4c92-8228-a017337d21a8&name=SkincareSunZoneUvProtectorFaceExposedAreasSpf50HighTheOne5in1ColourStylistLipstickGarnetAttraction23&inputFormat=jpg'
        }
    }
};
const mappedCategoryPageData = exports.mappedCategoryPageData = {
    application: {
        editorialLandingPage: {
            ...(_categoryPageData_application = categoryPageData.application) === null || _categoryPageData_application === void 0 ? void 0 : _categoryPageData_application.editorialLandingPage,
            landingPageId: 'Novage+',
            themeItems: (_categoryPageData_application1 = categoryPageData.application) === null || _categoryPageData_application1 === void 0 ? void 0 : (_categoryPageData_application_rootEditorialLandingPage = _categoryPageData_application1.rootEditorialLandingPage) === null || _categoryPageData_application_rootEditorialLandingPage === void 0 ? void 0 : _categoryPageData_application_rootEditorialLandingPage.themeItems
        }
    }
};
